module.exports = __webpack_public_path__ + "assets/img/footer_logo_6.cc7d8436.png";